"use client";

import React from "react";

import { createSVGIcon } from "../util";
import { Core } from "@faire/design-tokens";

/**
 * @figma designed by Brooklyn Brown (see [Figma](https://figma.com/file/qcB5qVN7uKBBYHN49ihDE7?node-id=5%3A1661))
 * @trackcomponent
 * @lastsynced 2025-04-03T16:51:39.136Z
 */
export const Caution = createSVGIcon(
  <path
    d="M12 8.57129V13.7141M13 19C13 19.5523 12.5523 20 12 20C11.4477 20 11 19.5523 11 19C11 18.4477 11.4477 18 12 18C12.5523 18 13 18.4477 13 19ZM13.5327 1.80506C13.3901 1.52069 13.1713 1.28158 12.9007 1.11448C12.63 0.947386 12.3182 0.858887 12.0001 0.858887C11.682 0.858887 11.3702 0.947386 11.0995 1.11448C10.8289 1.28158 10.61 1.52069 10.4675 1.80506L1.03895 20.6622C0.908385 20.9235 0.846748 21.2138 0.859891 21.5056C0.873033 21.7974 0.96052 22.081 1.11405 22.3295C1.26758 22.578 1.48206 22.7832 1.73713 22.9255C1.99221 23.0678 2.27943 23.1426 2.57152 23.1428H21.4287C21.7208 23.1426 22.008 23.0678 22.2631 22.9255C22.5181 22.7832 22.7326 22.578 22.8861 22.3295C23.0397 22.081 23.1272 21.7974 23.1403 21.5056C23.1534 21.2138 23.0918 20.9235 22.9612 20.6622L13.5327 1.80506Z"
    stroke="currentColor"
    strokeLinecap="round"
    strokeLinejoin="round"
  />,
  "Caution",
  { viewBox: "0 0 24 24", fill: "none", color: Core.icon.default } // This icon is decorative, keep titleAccess empty so it doesn't clutter the screenreader experience
);
